/* eslint-disable no-param-reassign */
import produce from 'immer';
import { REQUEST_USER_ROLES, GET_USER_ROLES } from 'src/actions/userRoleActions';

const initialState = {
  userRoles: [],
  isFetching: false,
  message: ''
};

const userRoleReducer = (state = initialState, action) => {
  switch (action.type) {
    case REQUEST_USER_ROLES: {
      return produce(state, (draft) => {
        draft.isFetching = true;
      });
    }

    case GET_USER_ROLES: {
      const { userRoles, message } = action.payload;

      return produce(state, (draft) => {
        draft.userRoles = userRoles;
        draft.isFetching = false;
        draft.message = message;
      });
    }

    default: {
      return state;
    }
  }
};

export default userRoleReducer;
